import { ObjUtils } from "../Utils/ObjUtils";
import { Device } from "./Device";
import { IpAddress } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { DeviceKey } from "./Keys";
import { DeviceSet } from "./DeviceSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { DeviceCategory } from "../Core/DeviceCategory";
import { DeviceCategories } from "../Core/DeviceCategories";
import { VendorNames } from "../InfoSets/ProductInfo";

//export interface DeviceGroupMemberJson {
//    device_key: DeviceKeyJson;
//    ip_address: string;
//    mac_address: string;
//    display_name: string;
//    oid: string;
//    description: string;
//}

export class DeviceGroupMember implements ObjectSerializer {

	public Key: DeviceKey;

	private CachedIpAddress: IpAddress;
	private get HasCachedIpAddress(): boolean {
		return !!this.CachedIpAddress;
	}

	private CachedMacAddress: MacAddress;
	private get HasCachedMacAddress(): boolean {
		return !!this.CachedMacAddress;
	}

	private CachedDisplayName: string;
	private get HasCachedDisplayName(): boolean {
		return !!this.CachedDisplayName;
	}

	private CachedSystemOID: string;
	private get HasCachedSystemOID(): boolean {
		return !!this.CachedSystemOID;
	}

	private CachedSystemDescription: string;
	private get HasCachedSystemDescription(): boolean {
		return !!this.CachedSystemDescription;
	}

	private CachedVendor: string;
	private get HasCachedVendor(): boolean {
		return !!this.CachedVendor;
	}

	private CachedNotes: string;
	private get HasCachedNotes(): boolean {
		return !!this.CachedNotes;
	}

	private CachedCategories: DeviceCategories;
	private get HasCachedCategories(): boolean {
		return (this.CachedCategories && this.CachedCategories.Count > 0);
	}

	// TRANSIENT - NOT PERSISTED
	public Device: Device;
	public get HasDevice(): boolean {
		return !!this.Device;
	}

	public get IpAddress(): IpAddress {
		return this.HasDevice ? this.Device.IpAddress : this.CachedIpAddress;
	}

	public get HasIpAddress(): boolean{
		return !!this.IpAddress;
	}

	public get MacAddress(): MacAddress {
		return this.HasDevice ? this.Device.MacAddress : this.CachedMacAddress;
	}

	public get HasMacAddress(): boolean {
		return !!this.MacAddress;
	}

	public get DisplayName(): string {
		return this.HasDevice ? this.Device.DisplayName : this.CachedDisplayName;
	}

	public get HasDisplayName(): boolean {
		return !!this.DisplayName;
	}

	public get SystemOID(): string {
		if (this.HasDevice) {
			if (this.Device.HasSystemInfo && this.Device.SystemInfo.HasSystemOID)
				return this.Device.SystemInfo.SystemOID;
			else
				return '';
		} else {
			return this.CachedSystemOID;
		}
	}

	public get HasSystemOID(): boolean {
		return !!this.SystemOID;
	}

	public get SystemDescription(): string {
		if (this.HasDevice) {
			if (this.Device.HasSystemInfo && this.Device.SystemInfo.HasSystemDescription)
				return this.Device.SystemInfo.SystemDescription;
			else
				return '';
		} else {
			return this.CachedSystemDescription;
		}
	}

	public get HasSystemDescription(): boolean {
		return !!this.SystemDescription;
	}

	public get Vendor(): string {
		if (this.HasDevice) {
			if (this.Device.HasProductInfo && this.Device.ProductInfo.HasVendor)
				return this.Device.ProductInfo.Vendor;
			else
				return '';
		}
		else {
			return this.CachedVendor;
		}
	}

	public get HasVendor(): boolean {
		return !!this.Vendor;
	}

	public get Notes(): string {
		if (this.HasDevice) {
			if (this.Device.HasNotesInfo && this.Device.NotesInfo.HasValue)
				return this.Device.NotesInfo.Value;
			else
				return "";
		}
		else {
			return this.CachedNotes;
		}
	}

	public get HasNotes(): boolean {
		return !!this.Notes;
	}

	public get Categories(): DeviceCategories {
		if (this.HasDevice) {
			return this.Device.Categories;
		}
		else {
			return this.CachedCategories;
		}
	}

	public get HasCategories(): boolean {
		return (this.Categories && this.Categories.Count > 0);
	}
		
    constructor(device?: Device) {
		this.Key = null;
		this.CachedIpAddress = null;
		this.CachedMacAddress = null;
		this.CachedDisplayName = "";
		this.CachedSystemOID = "";
		this.CachedSystemDescription = "";
		this.CachedVendor = "";
		this.CachedNotes = "";
		this.CachedCategories = null;
		this.Device = null;

		if (device) {
            this.Key = device.CreateKey();

            if (device.HasIpAddress)
                this.CachedIpAddress = device.IpAddress.Clone();

            if (device.HasMacAddress)
                this.CachedMacAddress = device.MacAddress.Clone();

            this.CachedDisplayName = device.DisplayName;

            if (device.HasSystemInfo && device.SystemInfo.HasSystemOID)
                this.CachedSystemOID = device.SystemInfo.SystemOID;

            if (device.HasSystemInfo && device.SystemInfo.HasSystemDescription)
                this.CachedSystemDescription = device.SystemInfo.SystemDescription;

			if (device.HasProductInfo && device.ProductInfo.HasVendor)
				this.CachedVendor = device.ProductInfo.Vendor;

			if (device.HasNotesInfo && device.NotesInfo.HasValue)
				this.CachedNotes = device.NotesInfo.Value;

			if (device.Categories.Count > 0)
				this.CachedCategories = device.Categories.Copy();

            this.Device = device;
        }
	}

	public Rebuild(deviceSet: DeviceSet):void {
		this.Device = null;

		this.Device = this.Key.Resolve(deviceSet);
	}
		
	public Equals(obj: any): boolean {
		if (!obj)
			return false
		if (obj == this)
			return true;

		if (!(obj instanceof DeviceGroupMember))
			return false;

		var other = <DeviceGroupMember> obj;

		return ObjUtils.Equals(this.Key, other.Key);
	}

    //public static FromJson(json: DeviceGroupMemberJson): DeviceGroupMember {
    //    var result = new DeviceGroupMember();

    //    if (json.device_key !== undefined)
    //        result.Key = DeviceKey.FromJson(json.device_key);

    //    if (json.ip_address !== undefined)
    //        result.CachedIpAddress = IpAddress.Create(json.ip_address);

    //    if (json.mac_address !== undefined)
    //        result.CachedMacAddress = MacAddress.CreateFromString(json.mac_address);

    //    if (json.display_name !== undefined)
    //        result.CachedDisplayName = json.display_name;

    //    if (json.oid !== undefined)
    //        result.CachedSystemOID = json.oid;

    //    if (json.description !== undefined)
    //        result.CachedSystemDescription = json.description;

    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.device_group_member = {};
		obj = obj.device_group_member;

		this.Key.Write(obj, context);

		if (this.HasCachedIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.CachedIpAddress);

		if (this.HasCachedMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.CachedMacAddress);

		if (this.HasCachedDisplayName)
			obj.display_name = this.CachedDisplayName;

		if (this.HasCachedSystemOID)
			obj.oid = this.CachedSystemOID;

		if (this.HasCachedSystemDescription)
			obj.description = this.CachedSystemDescription;

		if (this.HasCachedVendor)
			obj.vendor = this.CachedVendor;

		if (this.HasCachedNotes)
			obj.notes = this.CachedNotes;

		if (this.HasCachedCategories)
			this.CachedCategories.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.device_group_member)
			throw new Error();
		obj = obj.device_group_member;

		if (obj.device_key !== undefined) {
			this.Key = new DeviceKey();
			this.Key.Read(obj, context);
		}

		if (obj.ip_address !== undefined)
			this.CachedIpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

		if (obj.mac_address !== undefined)
			this.CachedMacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

		if (obj.display_name !== undefined)
			this.CachedDisplayName = obj.display_name;

		if (obj.oid !== undefined)
			this.CachedSystemOID = obj.oid;

		if (obj.description !== undefined)
			this.CachedSystemDescription = obj.description;

		if (obj.vendor !== undefined)
			this.CachedVendor = obj.vendor;

		if (obj.notes !== undefined)
			this.CachedNotes = obj.notes;

		if (obj.device_categories !== undefined) {
			this.CachedCategories = new DeviceCategories();
			this.CachedCategories.Read(obj, context);
		}
	}

}
